import React from "react";
import { useIsFocused } from "@react-navigation/native";

export function withUnmountOnBlur<T extends object>(
  Component: React.ComponentType<T>
) {
  return function WithUnmountOnBlur(props: T) {
    const isFocused = useIsFocused();

    // Only render the component when the screen is focused
    return isFocused ? <Component {...props} /> : null;
  };
}
